'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import PropTypes from 'prop-types';
import { forwardRef } from '@mui/x-internals/forwardRef';
import { GridOverlay } from '@mui/x-data-grid';
import { useGridApiContext } from "../hooks/utils/useGridApiContext.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const GridEmptyPivotOverlay = forwardRef(function GridEmptyPivotOverlay(props, ref) {
  const apiRef = useGridApiContext();
  return /*#__PURE__*/_jsx(GridOverlay, _extends({}, props, {
    ref: ref,
    children: apiRef.current.getLocaleText('emptyPivotOverlayLabel')
  }));
});
if (process.env.NODE_ENV !== "production") GridEmptyPivotOverlay.displayName = "GridEmptyPivotOverlay";
process.env.NODE_ENV !== "production" ? GridEmptyPivotOverlay.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { GridEmptyPivotOverlay };